module.exports = __webpack_public_path__ + "img/hero_sp.203665b0.jpg";